var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown, Icon, Pagination, Segment } from "semantic-ui-react";
import { cls } from "@iscr/views/NUI/utils";
const defaultPageSizeOptions = [10, 30, 50, 100, 200, 1000, 10000];
export function WrappedListPagination(props) {
    const { children, top = true, bottom = true } = props, rest = __rest(props, ["children", "top", "bottom"]);
    return (_jsxs(_Fragment, { children: [top && _jsx(ListPagination, Object.assign({}, rest)), children, bottom && _jsx(ListPagination, Object.assign({}, rest))] }));
}
function ListPagination(props) {
    const setPage = (_e, { activePage }) => {
        console.log("setPage(%o)", activePage);
        const { onPageChange } = props;
        onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(activePage);
    };
    const { compact, data, page, pages = 1, total, pageSize, showPageSizeSelector = false, pageSizeOptions = defaultPageSizeOptions, boundaryRange = 5, } = props;
    if (!data)
        return null;
    const commonProps = {
        totalPages: pages,
        activePage: page,
        onPageChange: setPage,
        ellipsisItem: { content: _jsx(Icon, { name: "ellipsis horizontal" }), icon: true },
        firstItem: page > 2 ? { content: _jsx(Icon, { name: "angle double left" }), icon: true } : null,
        prevItem: page > 1 ? { content: _jsx(Icon, { name: "angle left" }), icon: true } : null,
        nextItem: page < pages ? { content: _jsx(Icon, { name: "angle right" }), icon: true } : null,
        lastItem: page < pages - 1 ? { content: _jsx(Icon, { name: "angle double right" }), icon: true } : null,
        className: "right floated clearing",
    };
    return (_jsx(Wrapper, { compact: compact, children: _jsxs("div", { className: cls("font-bold list-pagination flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 lg:gap-0", compact || "pb-10"), children: [_jsx("div", { className: "w-full lg:hidden flex justify-center scale-90 transform-origin-center", children: pages > 0 && _jsx(Pagination, Object.assign({}, commonProps, { size: "mini", siblingRange: 1, boundaryRange: 1 })) }), _jsxs("div", { className: "flex flex-col sm:flex-row text-sm sm:mx-auto lg:mx-0 gap-1 my-auto sm:justify-center sm:items-center", children: ["Total records: ", total, " \u00A0 \u00A0", _jsx("span", {}), (total && (_jsxs(_Fragment, { children: ["Showing records ", (page - 1) * pageSize + 1, "-", Math.min(page * pageSize, total)] }))) ||
                            null, " ", "\u00A0 \u00A0", _jsx("span", {}), showPageSizeSelector && (_jsx(Dropdown, { value: pageSize, text: "Page Size " + pageSize, options: pageSizeOptions.map(o => ({ text: o.toString(), value: o })), onChange: (_event, data) => {
                                var _a;
                                (_a = props.onPageSizeChange) === null || _a === void 0 ? void 0 : _a.call(props, parseInt(data.value));
                            }, icon: "dropdown", labeled: true, button: true, className: `icon !px-2 !py-0.5 !text-sm !font-semibold !text-black ${app.settings.iscr2 ? "!bg-is2-gray-50 hover:!bg-is2-blue-50" : ""}` }))] }), _jsx("div", { className: "hidden lg:block", children: pages > 0 && (_jsx(Pagination, Object.assign({}, commonProps, { size: "small", siblingRange: 3, boundaryRange: boundaryRange }))) })] }) }));
}
function Wrapper({ compact, children }) {
    if (compact) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx(Segment, { basic: true, clearing: true, style: { padding: 0 }, children: children }));
}
export default ListPagination;
